module.exports = "/_next/static/images/pricing-plans-consulting-service-5-23dbb4743b026f5eb951eaa26c69226e.webp";